export default {
    projectRef: 'zpzdxpppgjacuqpljlnu',
    intro: 'COTR is a community-driven platform for developers to create and share code snippets.',
    howItWorks: [
        {
            title: '💻 Create Snippets',
            description: 'Snippets are reusable code blocks that can be shared with the community. COTR uses AI to generate snippet metadata.',
        },
        {
            title: '☝️ Request Changes',
            description: 'Ask the AI bartender for code changes. Add comments. Optimize for readability. Play code golf.',
        },
        {
            title: '✍️ Edit',
            description: 'Edit snippets to improve clarity and accuracy. Use markdown for formatting.',
        },
        {
            title: '⬆️ Vote on Quality',
            description: 'Upvote helpful snippets to highlight the best content for the community.',
        },
    ],
}